import moment from 'moment'; 

const getPreviousMonth = (selectedMonth) => { 
    const date = moment(selectedMonth,'MMMM')
    
    date.subtract(1, 'months'); 

    const previousMonth = date.format('MMMM');
    
    return previousMonth;    
};

export default getPreviousMonth;
